import type { ChartConfigED, FieldTypes } from "@certa/types";
import type {
  GroupByDateLabels,
  MetricDataTypes,
  XAxisDataTypes
} from "@certa/common/types";

export const getOtherConfigXAxisED = (chartConfigED: ChartConfigED) => {
  const xAxis = {
    fieldTypes: [] as FieldTypes[],
    dataTypes: [] as XAxisDataTypes[],
    labelOutputTypes: [] as GroupByDateLabels[]
  };
  chartConfigED.groupBy
    .filter(groupBy => !groupBy.extraJSON.isForSecondaryXAxis)
    .forEach(groupBy => {
      const { fieldType, dataType, labelOutputType } = groupBy.extraJSON;
      xAxis.fieldTypes.push(fieldType);
      xAxis.dataTypes.push(dataType);
      xAxis.labelOutputTypes.push(labelOutputType);
    });
  return xAxis;
};

export const getOtherConfigYAxisED = (chartConfigED: ChartConfigED) => {
  const yAxis = {
    outputDataType: [] as MetricDataTypes[]
  };
  // when axisName = xAxis, at that time only outputDataType = "text"
  // that is why after filtering, outputDataType = MetricDataTypes only
  chartConfigED.operations
    .filter(operation => operation.extraJSON.axisName === "yAxis")
    .forEach(operation => {
      const { outputDataType } = operation.extraJSON;
      yAxis.outputDataType.push(outputDataType as MetricDataTypes);
    });
  return yAxis;
};
